import { render, staticRenderFns } from "./responsibleServicesByWeek.vue?vue&type=template&id=39616d66&scoped=true"
import script from "./index.js?vue&type=script&lang=js&external"
export * from "./index.js?vue&type=script&lang=js&external"
import style0 from "./responsibleServicesByWeek.vue?vue&type=style&index=0&id=39616d66&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39616d66",
  null
  
)

export default component.exports